import { Box } from '@mui/joy'

export function Logo() {
  return <Box component='img' src='/logo.svg' mx='auto' />
}
